import { AjaxWrapper } from './ajax-wrapper';
import { satGlobals } from '../../qaamgo/sat/helper/sat-globals';
import { testIsObject } from '../test-and-assert/test-base';

function isTest() {
    try {
        return window.location.host.match(/.test/) !== null;
    } catch (e) {}
    return false;
}

/**
 * @deprecated
 */
class PromiseAjaxWrapper {
    constructor() {
        this.ajax = new AjaxWrapper();
        this.cached = {};
    }

    /**
     * @deprecated
     */
    getOptions(endpoint, data) {
        const url = satGlobals.getApiUrl(endpoint);

        const options = this.ajax.getDefaultOptions(url);

        options.data = {};

        if (testIsObject(data)) {
            options.data = data;
        }

        return options;
    }

    /**
     * @deprecated
     */
    post(endpoint, data) {
        return new Promise((resolve, reject) => {
            const options = this.getOptions(endpoint, data);

            this.ajax
                .post(options)
                .done((response) => {
                    if (isTest()) {
                        console.log(`POST request to ${endpoint} returned:`);
                        console.log(response);
                    }

                    resolve(response);
                })
                .fail((jqXHR, textStatus, errorThrown) => {
                    if (isTest()) {
                        console.error(`POST request to ${endpoint} failed with:`);
                        console.error(`response:    ${jqXHR.response}`);
                        console.error(`status code: ${jqXHR.status}`);
                    }

                    reject({
                        code: 'RequestException',
                        http_status: jqXHR.status,
                        response: jqXHR.response,
                        responseText: jqXHR.responseText,
                    });
                });
        });
    }

    /**
     * @deprecated
     */
    postJson(endpoint, data) {
        return new Promise((resolve, reject) => {
            const options = this.getOptions(endpoint, data);

            this.ajax
                .postJson(options)
                .done((response) => {
                    if (isTest()) {
                        console.log(`POST_JSON request to ${endpoint} returned:`);
                        console.log(response);
                    }

                    resolve(response);
                })
                .fail((jqXHR, textStatus, errorThrown) => {
                    if (isTest()) {
                        console.error(`POST_JSON request to ${endpoint} failed with:`);
                        console.error(`response:    ${jqXHR.response}`);
                        console.error(`status code: ${jqXHR.status}`);
                    }

                    reject({
                        code: 'RequestException',
                        http_status: jqXHR.status,
                        response: jqXHR.response,
                    });
                });
        });
    }

    /**
     * @deprecated
     *
     * @param {String} endpoint
     * @param data
     * @param {Boolean} [cache=false]
     *
     * @returns {Promise}
     */
    get(endpoint, data, cache) {
        return new Promise((resolve, reject) => {
            if (cache === true) {
                if (testIsObject(this.cached[endpoint]) && Date.now() - this.cached[endpoint].lastUpdated < 60000) {
                    resolve(this.cached[endpoint].response);

                    return;
                }
            }

            const options = this.getOptions(endpoint, data);

            this.ajax
                .get(options)
                .done((response) => {
                    if (isTest()) {
                        console.log(`GET request to ${endpoint} returned:`);
                        console.log(response);
                    }

                    this.cached[endpoint] = {
                        response: response,
                        lastUpdated: Date.now(),
                    };

                    resolve(response);
                })
                .fail((jqXHR, textStatus, errorThrown) => {
                    if (isTest()) {
                        console.error(`GET request to ${endpoint} failed with:`);
                        console.error(`response:    ${jqXHR.response}`);
                        console.error(`status code: ${jqXHR.status}`);
                    }

                    reject({
                        code: 'RequestException',
                        http_status: jqXHR.status,
                        response: jqXHR.response,
                    });
                });
        });
    }
}

export { PromiseAjaxWrapper };
